import { Component, EventEmitter, inject, Injector, Input, OnInit } from '@angular/core';
import { IManagableObject } from "../../../IManagableObject";
import { BaseComponentWithDialog } from "../../../base-admin-panel/base-component-with-dialog";
import { ObjectsService } from "../../../../../services/objects.service";
import { SettingsService, TimezoneViewModel } from "../../../../../services/settings.service";
import { AccessRights, UsersService } from "../../../../../services/users.service";
import { MapObject, MapPoint } from "../../../../shared/components/simple-map/c.component";
import { JSProxyService } from "../../../../../services/jsproxy.service";
import { KeysService } from '../../../../../services/keys.service';
import { IconViewModel } from "../../../../../models/IconViewModel";
import { DeviceModelViewModel } from "../../../../../models/DeviceModelViewModel";
import { ObjectModel } from "../../../../../models/ObjectModel";
import { ObjectStatus } from "../../../../../models/ObjectStatusEnum";
import { CommandTemplateModel } from "../../../../../services/commands.service";

declare var $: any;

@Component({
  selector: 'object-main-part',
  templateUrl: './object-main-part.component.html',
  styleUrls: ['./object-main-part.component.css'],
  standalone: false
})
export class ObjectMainPartComponent extends BaseComponentWithDialog implements OnInit {

  @Input()
  public onOpen: EventEmitter<any>;

  @Input()
  public Object: ObjectModel;

  @Input()
  public Icons: IconViewModel[] = [];

  @Input()
  public Groups: IManagableObject[] = [];

  @Input()
  public Commands: IManagableObject[] = [];

  @Input('Keys')
  set onKeysSet(val) {
    this.Keys = val;
    this.FreeKeys = this.Keys;
  }
  public Keys: IManagableObject[] = [];
  public FreeKeys: IManagableObject[] = [];

  public models: DeviceModelViewModel[] = [];
  public timezones: TimezoneViewModel[] = [];
  public showTZ = false;
  public KeyGroups: IManagableObject[] = [];
  public canEditTrackers: boolean = false;

  private settingsService: SettingsService;
  private objectsService: ObjectsService;
  private jsProxyService: JSProxyService;
  private keysService: KeysService;
  public usersService: UsersService = inject(UsersService);
  constructor(injector: Injector) {
    super(injector);
    this.objectsService = injector.get(ObjectsService);
    this.settingsService = injector.get(SettingsService);
    this.jsProxyService = injector.get(JSProxyService);
    this.keysService = injector.get(KeysService);
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }

  public onColorSelected(event) {
    console.log("onColorSelected", event);
    this.Object.TrackColor = event;
  }

  public onIconChange(icon: IconViewModel) {
    this.Object.IconId = icon.Id;
    if (icon.Color) {
      this.Object.TrackColor = icon.Color;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();

    let me = this;
    this.onOpen.subscribe(() => {
      setTimeout(function () { me.updateTZ(); }, 100);
    });

    this.settingsService.getTimezones().subscribe(res => {
      this.timezones = res;
      this.updateTZ();
    });

    this.objectsService.GetObjectsModels()
      .subscribe(models => {
        this.models = models;
      });

    this.keysService.GetGroups()
      .subscribe(groups => {
        this.KeyGroups = groups;
      });
  }

  updateTZ() {
    this.showTZ = (this.Object.TimeZone == "UTC" || this.Object.TimeZone == "") ? false : true;

    if (this.Object.TimeZone == "")
      this.Object.TimeZone = this.timezones.find(tz => tz.Offset === 0).Name;
  }

  onIMEIInput($event: any) {
    if ($event != "")
      this.Object.IMEI = $event;
    else
      this.Object.IMEI = 0;
  }

  public selectPoint() {
    const mapDialog = this.jsProxyService.getComponent("CommonDialogs").openMapModal();

    mapDialog.onSubmit.subscribe(() => {
      if (mapDialog.points && mapDialog.points.length) {
        this.Object.DefLat = mapDialog.points[0].lat;
        this.Object.DefLng = mapDialog.points[0].lng;

        mapDialog.close();
      }
    });

    const mapObject = new MapObject();
    if (this.Object.DefLng != undefined && this.Object.DefLat != undefined)
      mapObject.points.push(new MapPoint(this.Object.DefLat, this.Object.DefLng));
    mapObject.modify = true;
    mapDialog.ShowObjects([mapObject]);
  }
  public onStaticChange(val: boolean) {
    if (val)
      this.Object.SetFlag("STATIC");
    else
      this.Object.ResetFlag("STATIC");
  }
  public onTypeChange(val: string) {
    this.Object.ResetFlag("CARTRACKER");
    this.Object.ResetFlag("PERSONAL");
    this.Object.ResetFlag("FUEL");
    this.Object.ResetFlag("SECURITY");
    this.Object.ResetFlag("TANK");
    this.Object.ResetFlag("GENERATOR");
    this.Object.ResetFlag("SEAL");
    this.Object.ResetFlag("GAS");

    this.Object.SetFlag(val);
  }

  protected readonly ObjectStatus = ObjectStatus;
}
